import { render, staticRenderFns } from "./WidgetTemplate.vue?vue&type=template&id=72fb391f&scoped=true"
import script from "./WidgetTemplate.vue?vue&type=script&lang=js"
export * from "./WidgetTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb391f",
  null
  
)

export default component.exports